import React, { useState, useContext } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import { Outlet } from "react-router-dom";
import ResponsiveAppBar from "./ResponsiveAppBar";
import { Box } from "@mui/system";
import WorkflowWizard from "../components/wizard/WorkflowWizard";
import { WizardContext } from "../components/wizard/Context";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "../styles/common.css";
import "../styles/wizard.css";
import { SideNav } from "../components/common/SideNav";
import UserRoleManagerDialog from "../components/user/UserRoleManagerDialog";
import ExportBackgroundDownload from "../components/common/ExportBackgroundDownload";
import Chat from "../routes/Chat";

function AppContent() {
  const [openDrawer, setOpenDrawer] = useState(true);
  const { state } = useContext(WizardContext);
  const { showWizard = false, showRoleManager = false } = state;
  const onAppBarToggle = () => setOpenDrawer(!openDrawer);

  const sideNavProps = { openDrawer, setOpenDrawer };
  return (
    <>
      <CssBaseline />
      <ExportBackgroundDownload />
      {showRoleManager && <UserRoleManagerDialog />}
      {showWizard && <WorkflowWizard />}
      <div className="container">
        <ResponsiveAppBar onToggle={onAppBarToggle} openDrawer={openDrawer}></ResponsiveAppBar>
        <SideNav {...sideNavProps} />
        <Box
          className="contentContainer"
          sx={{
            ml: openDrawer ? 30 : 8,
            mt: 3,
            transition: (theme) => {
              return theme.transitions.create("margin", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
              });
            },
          }}
        >
          <Outlet context={{ onAppBarToggle }} />
        </Box>
      </div>
      <Chat />
    </>
  );
}

export default AppContent;
